// react and mui stuff
import { useLocation } from 'react-router-dom';

import Button from "@mui/joy/Button"
import Typography from "@mui/joy/Typography"
import Sheet from "@mui/joy/Sheet"

// custom components
import { MetaProps } from '../components/metaprops';
import TwoSidedLayout from '../components/templates/landinglayout';

import { imgSrc } from '../utils/backend';

export default function Landing() {
  const loc = useLocation()
  return (
    <Sheet>
      <MetaProps path={loc.pathname}/>
      <TwoSidedLayout reversed>
        <Typography
          level="h1"
          sx={{ fontWeight: 'xl', fontSize: 'clamp(1.875rem, 1.3636rem + 2.1818vw, 3rem)' }}
        >
          !profile
        </Typography>
        <Typography textColor="text.secondary" sx={{ fontSize: 'lg', lineHeight: 'lg' }}>
          Manage your profile, view leaderboards, buy games, and so much more!
        </Typography>
        <Button
          size="lg"
          startDecorator={<img src={imgSrc("logos/discord.svg")} alt='' height="28px" />}
          sx={{ mt: 2, mb: 1 }}
          onClick={() => window.location.href = `${process.env.REACT_APP_BACKEND}/api/auth/discord?redirect=${encodeURIComponent(loc.pathname)}`}
        >
          Sign in with Discord
        </Button>
      </TwoSidedLayout>
    </Sheet>
  );
}